import {
	FormControl,
	MenuItem,
	Select,
	SelectChangeEvent,
	Typography,
} from "@mui/material";
import { useVevyTheme } from "./ThemeProvider";
import { useTranslation } from "react-i18next";

export default function ChangeColor() {
	const theme = useVevyTheme();
	const { t } = useTranslation();

	const changeColor = (event: SelectChangeEvent) => {
		theme.setColor(event.target.value);
	};

	return (
		<FormControl size='small'>
			<Select
				value={theme.getColor()}
				onChange={changeColor}
				renderValue={(c) => (
					<Typography variant='caption'>{t ? t(c) : c}</Typography>
				)}
			>
				{theme.getListColor()?.map((c: string, i: number) => {
					return (
						<MenuItem value={c} key={i}>
							<Typography variant='caption'>{t ? t(c) : c}</Typography>
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	);
}
